import React, { useRef, useEffect, useState } from "react";
// import Webcam from "react-webcam";
import { Camera as CameraIcon, RotateCcw, Zap } from "lucide-react";
import Webcam from "react-webcam";

interface FaceVerificationCameraProps {
  onCapture: (imageData: string) => void;
  isProcessing: boolean;
  handleRetry: () => void;
  cameraOpen: boolean;
}

const FaceVerificationCamera: React.FC<FaceVerificationCameraProps> = ({
  onCapture,
  isProcessing,
  handleRetry,
  cameraOpen,
}) => {
  const videoRef = useRef<any>(null);

  // const [stream, setStream] = useState<MediaStream | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>("");

  // Usage

  const capture = React.useCallback(() => {
    const imageSrc = videoRef?.current?.getScreenshot();
    console.log("imageSrc screenshot >> ",imageSrc);
    
    
    

    onCapture(imageSrc);
  }, [videoRef]);

  return (
    <div className="relative w-full  mx-auto  mt-6 xl:mt-[100px]">
      <div className="flex items-center justify-center">
        <div className="relative overflow-hidden w-[750px] rounded-2xl bg-gray-900 border border-gray-700 shadow-2xl  mt-16 md:mt-0">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900 z-10">
              <div className="flex flex-col items-center space-y-4">
                <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-300 text-sm">Starting camera...</p>
              </div>
            </div>
          )}

          {error && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900 z-10 p-6">
              <div className="text-center">
                <CameraIcon className="w-12 h-12 text-red-400 mx-auto mb-4" />
                <p className="text-red-400 text-sm mb-4">{error}</p>
                <button
                  onClick={() => {
                    handleRetry();
                  }}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors duration-200"
                >
                  Retry
                </button>
              </div>
            </div>
          )}
          <div className="justify-center items-center flex md:h-[460px] h-[350px]  ">
            <Webcam
              audio={false}
              // height={  720}
              ref={videoRef}
              screenshotFormat="image/jpeg"
              // width={1280}
              videoConstraints={{
                width: 1280,
                height: 720,
                facingMode: "environment",
              }}
            />
          </div>


     

          {/* Camera overlay */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute inset-4 border-2 border-cyan-400/30 rounded-xl">
              <div className="absolute top-0 left-0 w-6 h-6 border-l-2 border-t-2 border-cyan-400 rounded-tl-lg"></div>
              <div className="absolute top-0 right-0 w-6 h-6 border-r-2 border-t-2 border-cyan-400 rounded-tr-lg"></div>
              <div className="absolute bottom-0 left-0 w-6 h-6 border-l-2 border-b-2 border-cyan-400 rounded-bl-lg"></div>
              <div className="absolute bottom-0 right-0 w-6 h-6 border-r-2 border-b-2 border-cyan-400 rounded-br-lg"></div>
            </div>

            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="w-32 h-24 border-2 border-cyan-400/50 rounded-lg animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Controls */}
      <div className="flex justify-center items-center mt-10 md:mt-5 xl:mt-[50px]  space-x-4">
        <button
          onClick={capture}
          disabled={isProcessing || isLoading || !!error}
          className="relative px-8 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 disabled:from-gray-600 disabled:to-gray-700 text-white font-semibold rounded-full shadow-lg transition-all duration-200 hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
        >
          {isProcessing ? (
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Processing...</span>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <Zap className="w-5 h-5" />
              <span>Capture</span>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default FaceVerificationCamera;
